import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import VegitableImage from "../../assets/Vegetable-Prices.jpg";
import CottonImage from "../../assets/bale-management.webp";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useState } from "react";
import CustomButton from "../Components/Button";
import Input from "../Components/Input";
import { useMutation } from "react-query";
import {
  MaterialInwardEntry,
  getMaterialData,
  updateMaterialInwardStatus,
} from "./mutations/materialInward";
import { useQuery, useQueryClient } from "react-query";
import CameraComponent from "../Components/CameraComponent";
import Loader from "../Components/Loader";
import { handleToastMsg } from "../Components/Toast";
import { formatDate, formatTime } from "../../utils/formatDate";
import CustomDivider from "../Components/CustomDivider"

const Outline = styled(Grid)`
  border: 1px solid #000;
  width: 250px;
  height: 250px;
  text-align: center;
`;

function Materialnward() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(600));

  const [stepper, setStepper] = useState("SELECT_TYPE");
  const [referenceNo, setReferenceNo] = useState("");
  const [capturedImage, setCapturedImage] = useState(null);
  const [materialType, setMaterialType] = useState("");

  const [imageBoxVisible, setImageBoxVisible] = useState(true); // Track the ImageBox visibility
  const [mediaStream, setMediaStream] = useState(null);
  const [showCapture, setShowCapture] = useState(false);

  const { mutate, isLoading: createLoading } = useMutation(MaterialInwardEntry);
  const { mutate: statusMutate, isLoading: statusLoading } = useMutation(
    updateMaterialInwardStatus
  );
  const queryClient = useQueryClient();
  const { isLoading, data: materialData } = useQuery(
    "material-inward-transactions",
    () => getMaterialData(),
    {
      onSuccess: (res) => {
        console.log({ res });
      },
      refetchOnMount: true,
    }
  );

  console.log({ materialData });

  const updateStatus = (id) => {
    statusMutate(id, {
      onSuccess: (res) => {
        console.log({ res });
        handleToastMsg("Data updated successfully", "success");
        queryClient.invalidateQueries("material-inward-transactions");
      },
    });
  };

  const handleSubmit = () => {
    mutate(
      {
        invoice_num: referenceNo,
        image: capturedImage,
        type: materialType.toLowerCase(),
      },
      {
        onSuccess: (res) => {
          console.log({ res });
          setStepper("TABLE");
          handleToastMsg("Data submitted successfully", "success");
          queryClient.invalidateQueries("material-inward-transactions");
        },
      }
    );
  };

  if (isLoading || statusLoading) return <Loader />;

  return (
    <>
      <h4 style={{ textAlign: "center" }}>
        Materials Inward / உள்வரும் பொருள்
      </h4>
      <CustomDivider />
      {stepper && stepper === "SELECT_TYPE" && (
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          py={2}
          rowGap={4}
          style={{ cursor: "pointer" }}
        >
          <Grid
            item
            container
            justifyContent={"space-evenly"}
            columnGap={2}
            rowGap={3}
          >
            <Grid item textAlign={"center"}>
              <img
                src={VegitableImage}
                alt="img"
                width={250}
                height={250}
                style={{ objectFit: "cover", borderRadius: '10px' }}
                onClick={() => {
                  setMaterialType("CANTEEN");
                  setStepper("REFERNCE_NO");
                }}
              />
              <p style={{ marginTop: "5px" }}>
                Canteen Material / <br /> உணவக பொருட்கள்
              </p>
            </Grid>
            <Grid item textAlign={"center"}>
              <img
                src={CottonImage}
                alt=""
                width={250}
                height={250}
                style={{ objectFit: "cover", borderRadius: '10px' }}
                onClick={() => {
                  setMaterialType("RAW MATERIAL");
                  setStepper("REFERNCE_NO");
                }}
              />
              <p style={{ marginTop: "5px" }}>
                Raw Materials / <br /> மூல பொருட்கள்
              </p>
            </Grid>
            <Grid
              item
              textAlign={"center"}

              onClick={() => {
                setMaterialType("OTHERS");
                setStepper("REFERNCE_NO");
              }}
            >
              <Outline style={{ borderRadius: '10px' }}>
                <h4 style={{ marginTop: "105px" }}>Others / மற்றவைகள்</h4>
              </Outline>
            </Grid>
          </Grid>
          <Grid
            item
            container
            xs={10}
            justifyContent={isMobile ? "center" : "flex-end"}
          >
            <CustomButton onClick={() => setStepper("TABLE")}>
              View Queue / காட்சி வரிசை
            </CustomButton>
          </Grid>
        </Grid>
      )}

      {stepper && stepper === "REFERNCE_NO" && (
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={1}
        >
          <Grid
            item
            container
            xs={12}
            mt={{ xs: 2, md: 2 }}
            mb={{ xs: 2, md: 2 }}

            md={12}
            alignItems={'center'}
          >
            <Grid item style={{ cursor: "pointer" }}
              onClick={() => setStepper("SELECT_TYPE")}>
              <KeyboardBackspaceIcon />
            </Grid>
            <Grid item style={{ paddingLeft: '2%' }}><p>Material Type: {materialType.toLowerCase()}</p></Grid>
          </Grid>

          <Grid container direction={"column"} xs={10} md={6} rowGap={5}>
            <Grid container xs={12} rowGap={1}>
              <Grid container item xs={12} justifyContent={isMobile && "center"}>
                <p>Reference No / குறிப்பு எண்</p>
              </Grid>
              <Grid item container xs={6}>
                <Input
                  type="text"
                  value={referenceNo}
                  onChange={(e) => setReferenceNo(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid container xs={12} >

              <Grid item xs={3}>Image:</Grid>
              <Grid item xs={6}>
                <CameraComponent
                  capturedImage={capturedImage}
                  setCapturedImage={setCapturedImage}
                  setImageBoxVisible={setImageBoxVisible}
                  imageBoxVisible={imageBoxVisible}
                  setMediaStream={setMediaStream}
                  mediaStream={mediaStream}
                  showCapture={showCapture}
                  setShowCapture={setShowCapture}
                />
              </Grid>
            </Grid>
            <Grid item container justifyContent={"center"} py={1}>
              <CustomButton
                variant="contained"
                size="large"
                onClick={() => handleSubmit()}
                type="button"
                isLoading={createLoading}
              >
                Submit / சமர்ப்பிக்க
              </CustomButton>
            </Grid>
          </Grid>
        </Grid>
      )}

      {stepper && stepper === "TABLE" && (
        <Grid container>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Date / தேதி</TableCell>
                <TableCell align="center">Type / வகை</TableCell>
                <TableCell align="right">Reference No / குறிப்பு எண்</TableCell>
                <TableCell align="center">In time / உள்ளே நேரம்</TableCell>
                <TableCell align="center">Image / படம்</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(materialData) && materialData.length > 0 ? (
                materialData.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="center">{formatDate(row.date)}</TableCell>

                    <TableCell align="center">{row.type}</TableCell>
                    <TableCell align="center">{row.invoiceNum}</TableCell>
                    <TableCell align="center">
                      {formatTime(row.inTime)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <img
                        src={row.image}
                        alt="img"
                        width={250}
                        height={250}
                        style={{ objectFit: "contain" }}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <CustomButton onClick={() => updateStatus(row.id)}>
                        {" "}
                        Out / வெளியே
                      </CustomButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <h4>No Data Found</h4>
              )}
            </TableBody>
          </Table>
        </Grid>
      )}
    </>
  );
}

export default Materialnward;
